import type { ButtonHTMLAttributes, InputHTMLAttributes, ReactNode } from 'react';
import { Link, type LinkProps } from 'react-router-dom';
import styles from './ui.module.css';

export function Card({ children, className }: { children: ReactNode; className?: string }) {
  return <div className={`${styles.card} ${className ?? ''}`}>{children}</div>;
}

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'ghost';
}

export function Button({ variant = 'primary', className, ...rest }: ButtonProps) {
  const cls = variant === 'ghost' ? styles.buttonGhost : styles.button;
  return <button className={`${cls} ${className ?? ''}`} {...rest} />;
}

interface LinkButtonProps extends LinkProps {
  variant?: 'primary' | 'ghost';
}

export function LinkButton({ variant = 'ghost', className, ...rest }: LinkButtonProps) {
  const cls =
    variant === 'primary'
      ? `${styles.linkButton} ${styles.linkButtonPrimary}`
      : styles.linkButton;
  return <Link className={`${cls} ${className ?? ''}`} {...rest} />;
}

interface FieldProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
  id: string;
}

export function Field({ label, id, ...rest }: FieldProps) {
  return (
    <label className={styles.field} htmlFor={id}>
      <span className={styles.label}>{label}</span>
      <input id={id} className={styles.input} {...rest} />
    </label>
  );
}

export function Alert({ children }: { children: ReactNode }) {
  return <div className={styles.alert}>{children}</div>;
}

export function Notice({ children }: { children: ReactNode }) {
  return <div className={styles.notice}>{children}</div>;
}

export function Spinner({ label = 'Lädt…' }: { label?: string }) {
  return (
    <div className={styles.center}>
      <span className={styles.spinner} aria-hidden="true" />
      <div style={{ marginTop: 8 }}>{label}</div>
    </div>
  );
}
